import React from 'react';
import TokenService from '../../services/TokenService';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import AddBrand from './AddBrand';
import Skeleton from '@mui/material/Skeleton'
import BrandLookupItem from './BrandLookupItem';
import cloneDeep from 'lodash/cloneDeep';

export default function BrandLookup(props) {
    const [isLoading, setIsLoading] = React.useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [companyName, setCompanyName] = React.useState('');
    const [brandName, setBrandName] = React.useState('');
    const [searchResults, setsearchResults] = React.useState(null);

    const [brandLookupData, setBrandLookupData] = React.useState([]);
    const [showAddBrand, setShowAddBrand] = React.useState(false);

    React.useEffect(() => {
        loadBrands(); // only called once
    }, []);

    React.useEffect(() => {
        if (brandLookupData.length > 0) {
            search(); // occurs when brandLookupData changes
        }
    }, [brandLookupData]);

    React.useEffect(() => {
        search();
    }, [companyName, brandName]);

    function loadBrands() {
        setIsLoading(true);
        TokenService.post('', 'BrandLookup_Select')
            .then((response) => {

                if (response.Result === "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    setBrandLookupData(JSON.parse(data.BrandLookup));
                }
                setIsLoading(false);
            })
            .catch((response) => {
                setIsLoading(false);
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function search() {
        let results = null;
        let matches = [];
        if (brandName.length > 2 || companyName.length > 2) {
            results = {
                Accepted: [],
                NotAccepted: []
            };

            // searching
            for (let i = 0; i < brandLookupData.length; i++) {
                if (brandName.length > 2 || companyName.length > 2) {
                    if (brandLookupData[i].CompanyName.toUpperCase().indexOf(companyName.toUpperCase()) > -1) {
                        if (brandLookupData[i].BrandName.toUpperCase().indexOf(brandName.toUpperCase()) > -1) {
                            matches.push(brandLookupData[i]);
                        }
                    }
                }
                else if (companyName.length > 2) {
                    if (brandLookupData[i].CompanyName.toUpperCase().indexOf(companyName.toUpperCase()) > -1) {
                        matches.push(brandLookupData[i]);
                    }
                }
                else if (brandName.length > 2) {
                    if (brandLookupData[i].BrandName.toUpperCase().indexOf(brandName.toUpperCase()) > -1) {
                        matches.push(brandLookupData[i]);
                    }
                }
            }

            // sorting of most feedback on top?
            for (let i = 0; i < matches.length; i++) {
                if (matches[i].IsAccepted) {
                    results.Accepted.push(matches[i]);
                }
                else {
                    results.NotAccepted.push(matches[i]);
                }
             
            }
            if (results.Accepted.length == 0 && results.NotAccepted.lenght == 0) {
                results.push(<div>No matches found</div>)
            }
        }
        setsearchResults(results);
    }

    function handleAddBrand() {
        setShowAddBrand(true);
    }

    function handleAddBrandClosed(didAccept, brandData) {
        if (didAccept) {
            // post
            setIsLoading(true);
            let postData = {
                brand: brandData
            }
            TokenService.post(postData, 'BrandLookup_Add')
                .then((response) => {

                    if (response.Result === "SUCCESS") {
                        let data = JSON.parse(response.JsonData);
                        let brand = JSON.parse(data.Brand);
                        handleBrandLookupChanged(brand, 'Add')
                        /* setBrandLookupData(JSON.parse(data.BrandLookup));*/
                    }
                    else {
                        
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }
                    setIsLoading(false);
                })
                .catch((response) => {
                    setIsLoading(false);
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
        setShowAddBrand(false);
        
    }

    function handleBrandLookupChanged(brand, action) {
        let temp = cloneDeep(brandLookupData);
        if (action == 'Add') {
            brand.IsCurrentUser = true;
            if (sessionStorage.getItem('LoggedInUser') != null) {
                brand.Recycler = JSON.parse(sessionStorage.getItem('LoggedInUser'));
            }
          
            temp.push(brand);
        }
        else if (action == 'Update') {


        }
        else if (action == 'Delete') {
            for (let i = 0; i < temp.length; i++) {
                if (temp[i].BrandLookupId == brand.BrandLookupId) {
                    temp.splice(i, 1);
                }
            }
        }
        setBrandLookupData(temp);
    }

    return (
        <div componentname='BrandLoookup'>
                       
          
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <div style={{ color: 'var(--sipzee-grey)', fontSize: '18pt', fontWeight: 'bold' }}>
                            Brand Lookup
                        </div>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            Need help finding where is a brand accepted?
                    </div>
                    <div style={{ alignSelf: 'center', marginTop: '10px', fontStyle:'italic' }}>
                        This is a community lookup tool to help each other and yourself. Please let us know if anything needs to be removed.
                    </div>

                    {isLoading ?
                        <>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <Skeleton width={200} height={95} style={{ alignSelf: 'center' }} />
                        </div>
                         <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <Skeleton width={200} height={95} style={{ alignSelf: 'center' }} />
                            </div>
                        </>
                        :
                        <>
                            <div style={{ alignSelf: 'center', marginTop: '10px', display:'flex' }}>
                                <img src='images/BreweryIcon.png' style={{ height: '35px', alignSelf: 'center', marginRight: '10px' }} />
                                <TextField style={{ width: '200px', alignSelf: 'flex-start' }} label="Brand/Brewery" onChange={(e) => setCompanyName(e.target.value)} value={companyName} variant="outlined" />
                            </div>
                            <div style={{ alignSelf: 'center', marginTop: '10px', display:'flex' }}>
                                <img src='images/FlavorIcon.png' style={{ height: '35px', alignSelf:'center', marginRight:'10px' }} />
                                <TextField style={{ width: '200px', alignSelf: 'flex-start' }} label="Flavor" onChange={(e) => setBrandName(e.target.value)} value={brandName} variant="outlined" />
                            </div>
                        </>
                    }
                    </div>
                    {searchResults == null ? null :
                        <div style={{ marginLeft:'auto', marginRight:'auto', marginTop: '15px', maxWidth: '400px' }}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div><Fab size={'small'} sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => handleAddBrand()}><AddIcon /></Fab></div>
                            </div>
                            {searchResults.Accepted.length == 0 ? null :
                                <div style={{ marginTop: '20px', borderTop: '3px solid #efefef', textAlign: 'left' }}>Accepted at:</div>

                            }
                            {searchResults.Accepted.map((brand, i) => {
                                return <BrandLookupItem brand={brand} onChange={(brand, action) => handleBrandLookupChanged(brand, action)} />
                            })}

                            {searchResults.NotAccepted.length == 0 ? null :
                                <div style={{ marginTop:'20px', borderTop: '3px solid #efefef', textAlign:'left' }}>Not Accepted at:</div>
                                                               
                            }
                            {
                                searchResults.NotAccepted.map((brand, i) => {
                                    return <BrandLookupItem brand={brand} onChange={(brand, action) => handleBrandLookupChanged(brand, action)} />
                                })
                            }
                            
                            </div>
                        </div>
                }

                </div>
            
            {showAddBrand ? <AddBrand Close={(didAccept, brand) => handleAddBrandClosed(didAccept, brand)} companyName={companyName} brandName={brandName} /> : null}
           
        </div>
    )
}